import Head from "next/head"
import styles from "@/styles/company-news.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import { Pagination as AntPagination, Row, Skeleton, Image, message } from "antd";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination as SwiperPagination, Navigation } from 'swiper'
import NextImage from 'next/image'
import Link from 'next/link'
import getConfig from 'next/config'
import companyApi from "@/service/modules/companyApi"
import { useEffect, useState } from "react"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import 'swiper/css'
import 'swiper/css/pagination'
import ObserverSection from "@/components/ObserverSection";
export default function CompanyNews() {

  const [tabList, setTabList] = useState([{
    title: '最新动态',
    key: '1'
  }, {
    title: '企业内刊',
    key: '2'
  }])
  const [currentTab, setCurrentTab] = useState('1')
  const [articleList, setArticleList] = useState([])
  const [componentList, setComponentList] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(6)
  const [total, setTotal] = useState(0)
  const [topCharacter, setTopCharacter] = useState<any>([])
  const [articleLoading, setArticleLoading] = useState(false)
  const [companyNewsLoading, setCompanyNewsLoading] = useState(false)

  const [swiper, setSwiper]: any = useState(null);

  const slidePrev = () => {
    swiper.slidePrev()
  }

  const slideNext = () => {
    swiper.slideNext()
  }


  useEffect(() => {
    getArticleList()
  }, [])

  useEffect(() => {
    getCompanyNews()
  }, [page, pageSize])

  const pageChange = (page: number, pageSize: number) => {
    setPage(page)
    setPageSize(pageSize)
  }

  const getArticleList = async () => {
    try {
      setArticleLoading(true)
      const res = await companyApi.getArticleList()
      setArticleList(res.data)
      setArticleLoading(false)

    } catch (error: any) {
      setArticleLoading(false)
      // message.error(error.message)
    }
  }

  const getCompanyNews = async () => {
    try {
      setCompanyNewsLoading(true)
      const params = {
        page,
        page_size: pageSize
      }
      const res = await companyApi.getCompanyNews(params)
      setCompanyNewsLoading(false)
      const { dailies, characters } = res.data
      setTopCharacter(characters.items)

      const { items, total_cnt } = dailies
      setTotal(total_cnt)
      setComponentList(items)
    } catch (error: any) {
      setCompanyNewsLoading(false)
      message.error(error.message)
    }
  }
  return (
    <DefaultLayout>
      <div className={styles["page-about-us"]}>
        <div className={styles['banner-box']}>
          <Image
            className={styles['banner']}
            alt={'banner'}
            width={'100%'}
            style={{ minWidth: 1200 }}
            src={`${imageDomain}/banner/development-results.png`}
            preview={false}
          ></Image>

          {/* <div className={styles['banner-title']}>
            <div className={styles['language-english']}>Development Results</div>
            <div className={styles['language-chinese']}>公司动态</div>
          </div> */}
        </div>
        <div className={styles['main']}>
          {/* 发展成果 */}
          <div className={styles["advantages"]}>
            <ObserverSection customClassName="fade-in">
              <div className={styles['sub-title']}>
                <div className={styles['language-english']}>Development Achievements</div>
                <div className={styles['language-chinese']}>发展成果</div>
              </div>
            </ObserverSection>
            <ObserverSection customClassName="fade-in">
              <Row align="middle" justify="space-between">
                <div className={styles['advantages-list']}>
                  <div className={styles['advantages-list-item']}>2016年，eBay年度最优秀类目奖-HOME & GARDEN</div>
                  <div className={styles['advantages-list-item']}>2017年，eBay年度新星奖</div>
                  <div className={styles['advantages-list-item']}>2018年，eBay年度最畅销奖</div>
                  <div className={styles['advantages-list-item']}>2019年，eBay年度最优秀类目奖-HOME & GARDEN</div>
                  <div className={styles['advantages-list-item']}>2021年，eBay年度最优秀类目奖-HOME & GARDEN</div>
                  <div className={styles['advantages-list-item']}>2022年，eBay年度最优秀类目奖-HOME & GARDEN</div>

                  {/* dot */}
                  <div className={styles['dot-line']}>
                    <Image src={`${imageDomain}/company-news/prize-dot.png`} width="100%" preview={false} />
                  </div>
                </div>
                <div className={styles['advantages-prize']}>
                  <Image src={`${imageDomain}/company-news/prize.png`} width="100%" preview={false} />
                </div>
              </Row>
            </ObserverSection>
          </div>

          {/* 新闻 */}
          <div className={styles['news-box']} style={{ backgroundImage: `url("${imageDomain}/company-news/new-background.png")` }}>
            <div className={styles['max-width']}>
              <ObserverSection customClassName="fade-in">
                <div className={styles['sub-title']}>
                  <div className={styles['language-english']}>News of Jiebeili</div>
                  <div className={styles['language-chinese']}>公司新闻</div>
                </div>
              </ObserverSection>
              {
                companyNewsLoading
                  ?
                  <Skeleton active paragraph={{ rows: 2 }} />
                  :
                  <div className={`swiperSelf hover-show-arrows}`}>
                    <Swiper
                      direction="horizontal"
                      pagination={true}
                      modules={[SwiperPagination, Navigation]}
                      onSwiper={(swiper) => setSwiper(swiper)}
                    >
                      {
                        topCharacter.map((item: any) => (
                          <SwiperSlide key={item.id}>
                            <Link href={item.link || '/'} legacyBehavior>
                              <a className={styles['news-top']} target="_blank" rel="noopener noreferrer">
                                <div className={styles['news-top-img']}>
                                  <Image src={item.cover_img_link} style={{ objectFit: 'cover' }} width="100%" height="100%" preview={false} />
                                </div>
                                <div className={styles['news-top-info']}>
                                  <div className={styles['news-top-info-title']}>{item.title}</div>
                                  <div className={styles['news-top-info-date']}>{`by ${item.writer}/${item.published_date}`}</div>
                                  <div className={styles['news-top-info-content']}>
                                    {item.digest}
                                  </div>
                                </div>
                              </a>
                            </Link>
                          </SwiperSlide>
                        ))
                      }
                    </Swiper>
                    <div className="swiper-wrapper-prev" onClick={slidePrev}>
                      <NextImage
                        src={`${imageDomain}/company-news/arrow-left.png`}
                        alt={'banner'}
                        width={12}
                        height={20}></NextImage>
                    </div>
                    <div className="swiper-wrapper-next" onClick={slideNext}>
                      <NextImage
                        src={`${imageDomain}/company-news/arrow-right.png`}
                        alt={'banner'}
                        width={12}
                        height={20}></NextImage>
                    </div>
                  </div>
              }

              <div className={styles['news-all']}>
                <div className={styles['news-all-nav']}>
                  {
                    tabList.map((item: any) => {
                      return (
                        <div
                          className={`${styles['news-all-nav-item']} ${item.key === currentTab ? styles['active'] : ''}`}
                          onClick={() => { setCurrentTab(item.key) }}
                          key={item.key}
                        >
                          {item.title}
                        </div>
                      )
                    })
                  }
                </div>
                <div className={styles['news-all-list']}>
                  {
                    currentTab === '1'
                    &&
                    componentList.map((item: any) => {
                      const itemDate = new Date(item.updated_at)
                      const year = itemDate.getFullYear()
                      const month = itemDate.getMonth() + 1
                      const day = itemDate.getDate()

                      return (
                        <Link
                          href={item.link || '/'}
                          legacyBehavior
                          key={item.id}
                        >
                          <a className={styles['news-all-list-item']} rel="noopener noreferrer" target={"_blank"}>
                            <div className={styles['news-all-list-item-top']}>
                              <div className={styles['news-all-list-item-top-date']}>
                                <div className={styles['news-all-list-item-top-date-month-day']}>{month}·{day}</div>
                                <div className={styles['news-all-list-item-top-date-year']}>{year}</div>
                              </div>
                              <div className={styles['news-all-list-item-top-title']}>{item.title}</div>
                            </div>
                            <div className={styles['news-all-list-item-content']}>
                              <Image src={item.cover_img_link} preview={false} width="100%" />
                            </div>
                          </a>
                        </Link>
                      )
                    })
                  }

                  {
                    currentTab === '2'
                    &&
                    <>
                      {
                        articleList.map((item: any) => (
                          <Link
                            href={item.url || '/'}
                            legacyBehavior
                            key={item.id}
                          >
                            <a className={styles['articleList-item']} rel="noopener noreferrer" target={"_blank"}>
                              <Image src={item.first_image} preview={false} width="100%" />
                            </a>
                          </Link>
                        ))
                      }
                      <div className={styles['articleList-item']}></div>
                    </>
                  }

                  {
                    !!(currentTab === '1')
                    &&
                    <div className={styles['pagination']}>
                      <AntPagination current={page} pageSize={pageSize} showSizeChanger={false} hideOnSinglePage={true} total={total} onChange={pageChange} />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}